import { getBuildTimePwa } from './buildTimeConfig';

export const onboardingConfig = {
  postLoginFeaturePrompt: getBuildTimePwa().installBanner,
};

export default onboardingConfig;
